import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { loginApi, getStoredToken } from '../../login/api/loginApi';
import type { MeResponse } from '../../login/types/login';

export function useMe() {
  const queryClient = useQueryClient();

  // R7-047: storage 변경(토큰 갱신/로그아웃) 시 ['auth', 'me'] 와 ['catalog'] 무효화
  // 다른 탭에서 로그아웃하거나 토큰이 교체될 때 UI 가 stale 상태로 남는 문제 방지
  useEffect(() => {
    const handler = (e: StorageEvent) => {
      if (e.key === 'eraf.access_token' || e.key === 'eraf.token') {
        void queryClient.invalidateQueries({ queryKey: ['auth', 'me'] });
        void queryClient.invalidateQueries({ queryKey: ['catalog'] });
      }
    };
    window.addEventListener('storage', handler);
    return () => window.removeEventListener('storage', handler);
  }, [queryClient]);

  return useQuery<MeResponse>({
    queryKey: ['auth', 'me'],
    queryFn: () => loginApi.me(),
    staleTime: 5 * 60 * 1000,
    retry: false,
    enabled: !!getStoredToken(),
  });
}
